import React from 'react'
import { Typography } from '@grammarly/badger-ui'

import { TypeItemFeatureHighlight } from '../../../../lib/types'
import { ComponentContentTypes } from '../../../../lib/types/content-types'
import { SectionContent } from '../../../../lib/types/section'
import { ContentRenderer } from '../../../renderer'
import { renderRichTextSingleLineContent, renderRichTextMultiLineContent } from '../../../renderer/rich-text'

import styles from './card.module.scss'

const { HS, C3, C4 } = Typography

interface CardFeatureHighlightProps {
  structure: TypeItemFeatureHighlight
}

const CtaCardFeatureHighlight: React.FC<CardFeatureHighlightProps> = ({ structure }) => {
  const { title, description } = structure.fields

  return (
    <>
      {title && (
        <C3 as="div">
          <b>{renderRichTextSingleLineContent(title)}</b>
        </C3>
      )}
      {description && (
        <C4 as="div" className={styles.description}>
          {renderRichTextMultiLineContent(description)}
        </C4>
      )}
    </>
  )
}

export const WallFeatureHighlight: React.FC<CardFeatureHighlightProps> = ({ structure }) => {
  const { title, description } = structure.fields

  return (
    <>
      {title && (
        <HS as="h2">
          <b>{renderRichTextSingleLineContent(title)}</b>
        </HS>
      )}
      {description && (
        <C4 as="div" className={styles.description}>
          {renderRichTextMultiLineContent(description)}
        </C4>
      )}
    </>
  )
}

interface SingleColumnCustomContentProps {
  content?: SectionContent
}

export const SingleColumnCtaCardContent: React.FC<SingleColumnCustomContentProps> = ({ content }) => {
  if (!content || !content.length) {
    return null
  }

  return (
    <>
      {content.map((field) => {
        const isItemFeatureHighlight = field.sys.contentType.sys.id === ComponentContentTypes.ItemFeatureHighlight
        return isItemFeatureHighlight ? (
          <CtaCardFeatureHighlight key={field.sys.id} structure={field as TypeItemFeatureHighlight} />
        ) : (
          <ContentRenderer key={field.sys.id} structure={field} />
        )
      })}
    </>
  )
}

export const SingleColumnWallContent: React.FC<SingleColumnCustomContentProps> = ({ content }) => {
  if (!content || !content.length) {
    return null
  }

  return (
    <>
      {content.map((field) => {
        const isItemFeatureHighlight = field.sys.contentType.sys.id === ComponentContentTypes.ItemFeatureHighlight
        return isItemFeatureHighlight ? (
          <WallFeatureHighlight key={field.sys.id} structure={field as TypeItemFeatureHighlight} />
        ) : (
          <ContentRenderer key={field.sys.id} structure={field} />
        )
      })}
    </>
  )
}
